<template>
  <img :src="src" :alt="alt"/>
</template>
<script>
export default {
  name: 'm-img',
  props: {
    src: {
      type: String,
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      type: String,
      default: 'mix it web'
    }
  }
}
</script>